import { css } from '@emotion/react';
export const cssVars = {
  alignItems: '--align-items',
  elemBeforeHeight: '--elem-before-height'
};
export const refinementTagStyles = css({
  '> span': {
    margin: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} 0px`,
    alignItems: `var(${cssVars.alignItems})`,
    '> span': {
      maxWidth: 'var(--content-width)',
      '&:has([data-testid="command-palette-rovo-agent-icon"])': {
        height: `var(${cssVars.elemBeforeHeight})`
      }
    }
  }
});